import {connect} from 'react-redux';
import {actions} from '../../actions/actions';
import {Settings} from '../settings';

export const SettingsContainer = connect(
  function mapStateToProps(state) {
    return {
      authenticated: state.authReducer.authenticated,
      online: state.onlineReducer.online
    };
  },
  function mapDispatchToProps(dispatch){
      return{
        onRegister: (email, pw) => {
         console.log("Register with email "+email)
         //dispatch with payload, handled by FirebaseAPI
         dispatch(actions.register(email, pw));
        },
        onLogin: (email, pw) => {
         console.log("Login with email "+email)
         dispatch(actions.logIn(email, pw));
        },
        onLogout: ()=>{
            console.log("Logging out")
        }
      }
  }

)(Settings);



// WEBPACK FOOTER //
// ./../../../Documents/codeprojects/leaflet-v02/src/components/containers/settingsContainer.js